import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=13b0eb11&"
import script from "./Tables.vue?vue&type=script&lang=js&"
export * from "./Tables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tables.vue"
export default component.exports